import React, { useContext, useEffect } from "react";
import navContext from "../../context/nav/navContext";
import DataContext from "../../context/data/dataContext";
import AuthContext from "../../context/auth/authContext";
import MobileNavigation from "../../components/nav/MobileNavigation";
import NotificationsList from "../../components/notifications/Notifications";
import MspDashboard from "./dashboard/MspDashboard";
import ConnectionsList from "./connections/Connections";
import TMobilePool from "./pools/TMobileUsagePoolWidget";
import AttPool from "./pools/AttUsagePoolWidget";
import VzWPool from "./pools/VerizonUsagePoolWidget";
import Status from "../../components/tables/StatusList";
import Carriers from "../../components/tables/CarriersList";
import SubmitTicket from "../ticket/SubmitTicket";

const MspPortal = () => {
  const { currentPage, showMobileNav } = useContext(navContext);
  const { getMSPData, startLoading } = useContext(DataContext);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (user !== null) {
      if (user.role === "MSP") {
        startLoading();
        getMSPData(user._id);
      }
    }
    //eslint-disable-next-line
  }, []);

  if (showMobileNav) {
    return <MobileNavigation />;
  } else {
    switch (currentPage) {
      default:
      case "dashboard":
        return <MspDashboard />;
      case "connectionsList":
        return <ConnectionsList />;
      case "notificationsList":
        return <NotificationsList />;
      case "tmobilePool":
        return <TMobilePool />;
      case "attPool":
        return <AttPool />;
      case "vzwPool":
        return <VzWPool />;
      case "status":
        return <Status />;
      case "carriers":
        return <Carriers />;
      case "submitTicket":
        return <SubmitTicket />;
    }
  }
};

export default MspPortal;
